import React from "react";
import { Link, useLocation } from "react-router-dom";
import Image from "../../../assets/logo.png";

const BreadCrump = () => {
  const location = useLocation();

  const paths = location.pathname.split("/").filter(Boolean);

  return (
    <>
    </>
    // <div
    //   className="relative min-h-[250px] flex items-center"
    //   style={{
    //     backgroundImage: `url(${Image})`,
    //     backgroundRepeat: "no-repeat",
    //     backgroundSize: "cover",
    //     backgroundPosition: "center",
    //   }}
    // >
    //   <div className="absolute inset-0 bg-black/40  z-0"></div>

    //   <div className="relative z-10 md:px-28 text-white">
    //     <h2 className="text-2xl font-bold mb-1 capitalize">
    //       {paths[paths.length - 1] || "Home"}
    //     </h2>
    //     <div className="flex items-center space-x-2  text-sm">
    //       <Link to="/" className="hover:underline text-white/80">Home</Link>
    //       {paths.map((path, index) => {
    //         const routeTo = `/${paths.slice(0, index + 1).join("/")}`;
    //         const isLast = index === paths.length - 1;
    //         return (
    //           <span key={index} className="flex items-center">
    //             <span className="mx-1 text-white/60">/</span>
    //             {isLast ? (
    //               <span className="capitalize">{path}</span>
    //             ) : (
    //               <Link to={routeTo} className="hover:underline capitalize text-white/80">
    //                 {path}
    //               </Link>
    //             )}
    //           </span>
    //         );
    //       })}
    //     </div>
    //   </div>
    // </div>
  );
};

export default BreadCrump;
